import React, { useState } from 'react';
import { validatePassword } from '../../../utils/validators';
import BackButton from '../../BackButton/BackButton';
import Button from '../../Button/Button';
import Input from '../../Input/Input';
import style from './NewPassword.module.css';

const NewPasswordForm = ({ setActiveComponent, onPasswordChanged }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validationState, setValidationState] = useState('invalid');
  const [error, setError] = useState('');

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setValidationState(validatePassword(newPassword) ? 'valid' : 'invalid');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (!validatePassword(password)) {
      setError(
        'Password must be at least 8 characters long and include at least one letter and one number or special character.',
      );
      return;
    }
    onPasswordChanged(password);
  };

  const isFormValid =
    password &&
    confirmPassword &&
    password === confirmPassword &&
    validationState === 'valid';

  return (
    <div className={style.new_pass_container}>
      <BackButton onClick={() => setActiveComponent('login')} />
      <h2 className={style.title_new_pass}>Створення нового паролю</h2>
      <p className={style.text_offer}>
        Будь ласка, створіть новий пароль для входу
        <br /> до вашого облікового запису.
      </p>
      <form onSubmit={handleSubmit} className={style.new_pass_form}>
        <Input
          id="password"
          labelText="Новий Пароль"
          type="password"
          value={password}
          onChange={handlePasswordChange}
          required
        />
        <Input
          id="confirmPassword"
          labelText="Повторіть Пароль"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        {error && <p>{error}</p>}
        <p className={style.text_rules}>
          Пароль повинен містити щонайменше 8 символів.
          <br /> Включати одну літеру та одну цифру або символ.
        </p>
        <Button
          disabled={!isFormValid}
          valid={isFormValid}
          type="submit"
          text={'Створити'}
        />
      </form>
    </div>
  );
};

export default NewPasswordForm;
